import { composeIO } from 'react-compose-io'
import { modalAdicionarTipoLancamento } from './ModalAdicionarTipoLancamento.IO'
import { ModalAdicionarTipoLancamentoView } from './ModalAdicionarTipoLancamento.View'

export const ModalAdicionarTipoLancamento = composeIO(ModalAdicionarTipoLancamentoView, modalAdicionarTipoLancamento)
